/*global mdui */

require('promise.prototype.finally').shim();


import {
    IEGoto,
    browerDifferenceHandle,
    imgPreload,
} from "@utils/browerHandle";


window.$md = mdui ? mdui.JQ : {};


IEGoto();
browerDifferenceHandle();


// imgPreload();
